import { EPromoType, IPromoInfoSchema } from '../../../repositories/newbuilding-card/entities/promo/PromoInfoSchema';

export const getAuthorName = (promo: IPromoInfoSchema): string | null | undefined => {
  const isCianMortgage = promo.promoType === EPromoType.CianMortgage;

  return isCianMortgage ? 'Циан.Ипотека' : promo.authorName;
};
